// =============================================================================
// synchronisation/BoutonSynchroCowork.js : le bouton « Synchroniser avec
// Cowork » de la barre du haut (demande de Pierre du 14/10/2026), réservé au
// super-administrateur strict de la session RÉELLE (App le décide, comme la
// page « Synchronisation »).
// -----------------------------------------------------------------------------
// Un clic lance les six échanges (Budget, Affaires publiques, Conformité,
// Mutuelles en clair, Fondations, puis les profils des élus),
// l'un après l'autre, et ouvre un panneau qui dit leur avancée ; un clic
// pendant un passage ne relance rien, il rouvre le panneau. Le moteur
// (./synchroRapide) et le panneau (./PanneauSynchroCowork) se chargent au
// premier clic : le bundle principal ne porte que ce bouton. Le panneau ne
// garde aucune saisie : FeuilleNavigation, comme les notifications. Pour lire
// les défauts, réglages et journaux : la page.
// =============================================================================
import React, { Suspense, useRef, useState } from "react";
import { Icone } from "../icones";
import { toast } from "../toasts";
import { lazyPrechargeable } from "../lazyRetry";

// Le panneau (FeuilleNavigation, HubSection) se charge à la demande, comme
// « Moi » : importé ici, il partirait dans le bundle principal et
// FeuilleNavigation y perdrait ses styles (voir PanneauSynchroCowork.js).
const PanneauSynchroCowork = lazyPrechargeable(() => import("./PanneauSynchroCowork"));

export default function BoutonSynchroCowork({ session, onNav }) {
  const [ouvert, setOuvert] = useState(false);
  const [etat, setEtat] = useState(null);   // { enCours, etapes: { cle: x }, resume }
  const moteur = useRef(null);
  const enCours = !!(etat && etat.enCours);

  const lancer = async () => {
    if (enCours) return;
    setEtat({ enCours: true, etapes: {}, resume: "" });
    try {
      const m = moteur.current || (moteur.current = await import("./synchroRapide"));
      const { resume, resultats } = await m.synchroniserTout(session, (cle, x) =>
        setEtat((e) => ({ ...e, etapes: { ...(e ? e.etapes : {}), [cle]: x } })));
      setEtat((e) => ({ ...e, enCours: false, resume }));
      const mauvais = resultats.some((r) => ["echec", "erreur", "partiel"].includes(r.statut));
      (mauvais ? toast.warn : toast.success)(`Synchronisation avec Cowork : ${resume}`);
    } catch (e) {
      setEtat((x) => ({ ...(x || {}), enCours: false, resume: `Synchronisation impossible : ${(e && e.message) || "erreur inconnue"}.` }));
      toast.error("Synchronisation avec Cowork impossible.");
    }
  };

  const libelleEtat = (x) => {
    const L = moteur.current && moteur.current.ETATS_ETAPE;
    return x && L ? L[x.statut] || x.statut : "En attente";
  };
  const detail = (x) => {
    if (!x) return enCours ? "Attend son tour." : "";
    if (x.statut === "erreur") return moteur.current ? moteur.current.erreurEnMots(x) : x.erreur;
    if (x.statut === "ignore") return x.raison || "";
    return x.phrase || "";
  };

  return (
    <>
      <button type="button" className="cq-icone-bouton cq-synchro" onClick={() => { setOuvert(true); lancer(); }}
        aria-haspopup="dialog" aria-expanded={ouvert} aria-controls={ouvert ? "cq-synchro" : undefined} aria-busy={enCours || undefined}
        aria-label={enCours ? "Synchronisation avec Cowork en cours" : "Synchroniser avec Cowork"}
        title={enCours ? "Synchronisation avec Cowork en cours" : "Synchroniser avec Cowork"}>
        <Icone name="refresh" size={20} />
        {enCours && <span className="cq-compteur cq-compteur-point" aria-hidden="true" />}
      </button>
      {(ouvert || etat) && (
        <Suspense fallback={null}>
          <PanneauSynchroCowork ouvert={ouvert} onFermer={() => setOuvert(false)} etat={etat} libelleEtat={libelleEtat} detail={detail}
            onRelancer={lancer} onOuvrirPage={() => { setOuvert(false); onNav("super-synchronisation"); }} />
        </Suspense>
      )}
    </>
  );
}
